
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/marcas",
      function () {
        return require("private-next-pages/sitemap/marcas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/marcas"])
      });
    }
  